import React from 'react';
import { NotificationBox } from '@gumtree/ui-library/src/notification-box/notification-box';

const InfoMessage = ({
    isAdExpired,
    showAdIsRemovedMessage,
    isZeroResults,
    hasSearchQuery,
    noResultsMessage,
}: {
    isAdExpired: boolean;
    showAdIsRemovedMessage: boolean;
    isZeroResults: boolean;
    hasSearchQuery: boolean;
    noResultsMessage: string;
}) => {
    let message = '';
    if (isAdExpired || (showAdIsRemovedMessage && !isZeroResults)) {
        message =
            'Sorry, the ad you are looking for is no longer available. Please see similar ads below.';
    } else if (showAdIsRemovedMessage && isZeroResults) {
        message =
            'Sorry, the ad you are looking for is no longer available. There are currently no similar ads within.';
    } else if (isZeroResults && !hasSearchQuery) {
        message = noResultsMessage;
    }

    return message ? <NotificationBox message={message} iconType="info2" /> : <></>;
};

export default InfoMessage;
